/** px-4 (1rem) + half of h-5 icon (0.625rem) — aligns border with parent icon center */
export const PTS_SIDEBAR_ICON_CENTER_OFFSET = "1.625rem";

export const PTS_SIDEBAR_SUB_MENU_CLASS =
  "mx-0 min-w-0 translate-x-0 gap-1 border-l border-white/20 py-1 pl-3 ml-[var(--pts-sidebar-icon-center)]";

export const PTS_SIDEBAR_SUB_LINK_CLASS =
  "flex w-full items-center rounded-full px-4 py-2 text-sm text-white transition-colors hover:bg-[#334155]/50 hover:text-white data-[active=true]:bg-[#334155] data-[active=true]:font-medium data-[active=true]:text-secondary";

export const PTS_SIDEBAR_SUB_LINK_ACTIVE_CLASS =
  "bg-[#334155] text-secondary font-medium";

export const PTS_SIDEBAR_SUB_BUTTON_CLASS = "h-auto min-h-0 w-full p-0";

export const ptsSidebarCollapsibleTriggerClass = (
  isPathActive: boolean,
  isOpen: boolean
) =>
  `flex w-full items-center justify-between gap-3 rounded-full px-4 py-2.5 transition-colors ${
    isPathActive || isOpen
      ? "text-secondary bg-[#334155] font-medium"
      : "text-white hover:bg-[#334155]/50"
  }`;

export const ptsSidebarCollapsibleIconClass = (
  isPathActive: boolean,
  isOpen: boolean
) => `h-5 w-5 ${isPathActive || isOpen ? "text-secondary" : "text-white"}`;
